
import Vue from 'vue';

// Services and types
import DialogService from '~/services/DialogService';
import IdentityService, { User } from '~/services/IdentityService';

// Components
import Button from '~/components/builders/Base/Button.vue';
import DeleteAccountInput from './DeleteAccountInput.vue';

// Utils
import LocalStorageUtils from '~/utils/localStorageUtils';

export default Vue.extend({
    name: 'DeleteAccount',
    components: { Button },
    data() {
        return {
            hasRequestedDeletion: false,
        };
    },
    computed: {
        user(): User | undefined {
            return this.$store.getters['profileModule/getUser']();
        },
    },
    methods: {
        getStorageKey() {
            return this.user ? `delete-account-request-${this.user.id}` : '';
        },
        loadHasRequestedDeletion() {
            const value = LocalStorageUtils.getExpirableItem(this.getStorageKey());
            this.hasRequestedDeletion = value ? true : false;
        },
        setHasRequestedDeletion() {
            LocalStorageUtils.setExpirableItem(
                this.getStorageKey(),
                true,
                new Date().getTime() + 60 * 60 * 1000
            );
            this.hasRequestedDeletion = true;
        },

        openDeleteAccountDialog() {
            DialogService.openDialog({
                title: this.$t('account.settings.deleteAccount.deleteDialog.title').toString(),
                content: this.$t('account.settings.deleteAccount.deleteDialog.content').toString(),
                component: DeleteAccountInput,
                props: {
                    match: this.user?.email,
                    actionId: 'delete-account',
                },
                actions: [
                    {
                        title: this.$t('general.cancel').toString(),
                        variant: 'secondary',
                        action: ({ res }: { res: () => void }) => res(),
                    },
                    {
                        id: 'delete-account',
                        title: this.$t(
                            'account.settings.deleteAccount.deleteDialog.buttonDeleteAccount'
                        ).toString(),
                        variant: 'error',
                        action: ({ res }: { res: () => void }) => {
                            return this.deleteAccount()
                                .then(() => {
                                    res();
                                    this.setHasRequestedDeletion();
                                })
                                .then(() => {
                                    setTimeout(() => {
                                        this.openConfirmationDialog();
                                    }, 700);
                                });
                        },
                    },
                ],
            });
        },
        openConfirmationDialog() {
            DialogService.openDialog({
                title: this.$t('account.settings.deleteAccount.confirmDialog.title').toString(),
                content: this.$t('account.settings.deleteAccount.confirmDialog.content').toString(),
                actions: [
                    {
                        title: this.$t('general.ok').toString(),
                        variant: 'success',
                        action: ({ res }: { res: () => void }) => res(),
                    },
                ],
            });
        },
        deleteAccount() {
            const service = new IdentityService();
            return service.sendAccountDeletionRequest();
        },
    },
    watch: {
        user: {
            handler() {
                this.loadHasRequestedDeletion();
            },
            immediate: true,
        },
    },
});
